const normalizeQueryValue = (value: string | null): string =>
  (value ?? "").trim().toLowerCase();

export const hasTodayArrivalParam = (search: string): boolean => {
  const params = new URLSearchParams(search);
  const arrivalQueryParam = normalizeQueryValue(params.get("arrival"));
  const arrivalDateQueryParam = normalizeQueryValue(params.get("arrival_date"));

  return arrivalQueryParam === "today" || arrivalDateQueryParam === "today";
};
